import React from "react";
import { ReactComponent as Logo } from "../../components/MyTulu/PDF/TuluFooter.svg";
import styled from "styled-components/macro";

export default function Footer(props) {
  const { buildingName } = props;
  return (
    <FooterWrapper>
      <Logo style={{ height: 52, width: 180 }} />
      <FooterText>
        <span>{buildingName}</span>
        <span style={spanBorder}> Manufacturing plans</span>
      </FooterText>
    </FooterWrapper>
  );
}

const spanBorder = { marginRight: 10 };
const FooterWrapper = styled.div`
  display: flex;
  position: absolute;
  bottom: 50px;
  left: 80px;
`;
const FooterText = styled.div`
  font-size: 22px;
  margin-left: 24px;
  margin-top: 28px;
`;
